// @flow
import {connect} from "react-redux";
import React, { Component } from 'react';
import { Map, TileLayer, Marker } from 'react-leaflet';
import {locationService} from './../../services/locationService';
 
class OMap extends Component {
  constructor(props){
    super(props);
    this.state = {
      location : {
        lat: '35.67',
        lng:'51.43',
    }
    }

  }
  componentDidMount = async () => {
    try{
      const location = await locationService.getLocation();
      const {latitude:lat ,longitude : lng} = location.coords;
      this.setState({location : {lat, lng}})
    }catch(error){

    }
   
}

  render() {
    return (
      <Map center={this.state.location} zoom={18} 
      zoomControl={false} 
      doubleClickZoom={false} 
      closePopupOnClick={false}
      dragging={false} 
      zoomSnap={false} 
      zoomDelta= {false}
      trackResize= {false}
      touchZoom= {false}
      scrollWheelZoom={false}
        className={`h-100 w-100 ${!this.props.registerAttendace.isUserInWorkPlace ? "blur" : ""} `}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, &copy; <a href="https://neshan.org/">Neshan</a>'
          url="https://api.neshan.org/tile/raster/basemap/{z}/{x}/{y}?style=dreamy&Api-key=service.8585b72379a94243aca65d35a5eb43f2"
        />
        <Marker position={this.state.location}>
        </Marker>
      </Map>
    )
  }
}
const mapToStateProps = (state) => {
  return state
};
export default connect(mapToStateProps)(OMap);